import React from "react";

export default function EmployeePagination({
  currentPage,
  setCurrentPage,
  employeeData,
  ITEMS_PER_PAGE,
  searchQuery,
  goToPreviousPage,
  goToNextPage,
}) {
  return (
    <div className="pagination">
      <div>
        <button onClick={goToPreviousPage} disabled={currentPage === 1}>
          <i className="fa-solid fa-arrow-left-long"></i> Previous
        </button>
      </div>
      <div>
        {Array.from(
          { length: Math.ceil(employeeData.length / ITEMS_PER_PAGE) },
          (_, index) => {
            const startPage = currentPage - 5 > 0 ? currentPage - 5 : 1;
            const endPage =
              startPage + 9 < Math.ceil(employeeData.length / ITEMS_PER_PAGE)
                ? startPage + 9
                : Math.ceil(employeeData.length / ITEMS_PER_PAGE);
            return (
              index + 1 >= startPage &&
              index + 1 <= endPage && (
                <button
                  key={index}
                  onClick={() => setCurrentPage(index + 1)}
                  className={currentPage === index + 1 ? "active" : ""}
                >
                  {index + 1}
                </button>
              )
            );
          },
        )}
      </div>
      <div>
        <button
          onClick={goToNextPage}
          disabled={employeeData.length <= currentPage * ITEMS_PER_PAGE}
        >
          Next <i className="fa-solid fa-arrow-right-long"></i>
        </button>
      </div>
    </div>
  );
}
